import React from 'react';
import { products } from '../../data/products';
import ProductCard from '../ui/ProductCard';
import {useTranslation} from "react-i18next";

const InvestmentProducts: React.FC = () => {
  const { t } = useTranslation() as {
    t: (key: string, options?: any) => string;
  };
  const localizedProducts = products.map(product => ({
    ...product,
    description: t(product.description),
  }));
  return (
    <div className="py-12 md:px-20 px-6">
      {localizedProducts.map((product) => (
          <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
};

export default InvestmentProducts;